import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BRAND } from "../../data/brand";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/60 border-b border-white/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3 group">
          <img
            src={BRAND.logo}
            alt="Train With Tristian"
            className="h-10 w-10 object-contain transition-transform duration-500 group-hover:rotate-6"
          />
          <span className="font-display font-bold tracking-tight text-sm sm:text-base leading-none">
            TRAIN WITH<br className="hidden sm:block" />
            <span className="gold-text">TRISTIAN</span>
          </span>
        </a>

        <a
          href="#apply"
          data-testid="header-cta"
          className="group relative overflow-hidden border border-[#d4af37]/60 px-5 py-2.5 text-xs tracking-[0.15em] uppercase font-bold"
        >
          <span className="relative z-10 transition-colors duration-300 group-hover:text-black">
            Join Boot Camp
          </span>
          <span className="absolute inset-0 bg-[#d4af37] translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" />
        </a>
      </div>
    </motion.header>
  );
}
